import PopupWrapper from "../../components/PopupWrapper";
import { useState, useEffect } from "react";
import axiosInstance from "../../axios";
import { selected_authentication_server } from "../../deployment-config";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import FormBox from "../FormBox/FormBox";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import { roleType } from "../../Utils/constant";

const NewMsaPopup = () => {
  const [accountsWithMSAFlagY, setAccountsWithMSAFlagY] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const accessed_user = JSON.parse(localStorage.getItem("accessed_user"));
  const selectedAccount = useSelector((state) => state.account.selectedAccount);

  const { register, handleSubmit, watch, setValue } = useForm();
  const checkbox = watch("accept");


  const onSubmit = async (data) => {
    setShowPopup(false);

    // const id = toast.loading("Requests are being processed...");
    const user_id = accessed_user.user_id
    try {
        const requestPromises = accountsWithMSAFlagY.map(async (account) => {
            const requestData = {
                recid: account.recid,
                user_id: user_id,
            };

            return axiosInstance.post(
                selected_authentication_server.msa_accepted.endpoint,
                requestData,
                selected_authentication_server.msa_accepted.headers
            );
        });

        const responses = await Promise.all(requestPromises);

        responses?.forEach((res, index) => {
            if (res.status === 200 || res.statusText === "OK") {
                // toast.success(`Request submitted successfully for account ${accountsWithMSAFlagY[index].recid}`);
                const updatedArray1 = accessed_user.account?.map(item1 => {
                  const matchingItem = accountsWithMSAFlagY?.find(item2 => item2.recid === item1.recid);
                  if (matchingItem) {
                      return { ...item1, msa_flag: "Y" };
                  }
                  return item1;
              });
              accessed_user.account = updatedArray1;
      
              localStorage.setItem('accessed_user', JSON.stringify(accessed_user));
            } else {
                // toast.error(`Failed to submit request for account ${accountsWithMSAFlagY[index].recid}`);
            }
        });
    } catch (error) {
        // toast.error("An error occurred while processing requests");
    } finally {
        // setTimeout(() => {
        //     toast.dismiss(id);
        // }, 1000);
    }
};

  useEffect(() => {
    const filterOne = accessed_user.account?.filter((account) => account.recid === selectedAccount.value);
    const filteredAccounts = filterOne?.filter(
      (account) => account.msa_flag === "N"
    );

    if (filteredAccounts?.length >= 1) {
      setShowPopup(true);
      setAccountsWithMSAFlagY(filteredAccounts)
    } else {
      setShowPopup(false);
    }
  }, [selectedAccount]);

  return (
    <div>
      {selectedRole === roleType.lender && (
        <PopupWrapper
          title="Accept MSA"
          extraClass="width-800"
          Component={
            <div>
              <form>
                <FormBox
                  options={checkingFormArr}
                  register={register}
                  watch={watch}
                  setValue={setValue}
                />
                <Button
                  className="text-white mt-5"
                  onClick={handleSubmit(onSubmit)}
                  disabled={!checkbox}
                >
                  Accept
                </Button>
              </form>
            </div>
          }
          toShow={showPopup}
          closeEventHandler={() => {
            setShowPopup(false);
          }}
        />
      )}
      <style>
        {`.span-color span {
        color: black
     }
    `}
      </style>
    </div>
  );
};

export default NewMsaPopup;

const checkingFormArr = [
  {
    title: "Please accept the MSA to proceed",
    field: "accept",
    type: "checkbox",
  },
];
